import CorePageTitle from './page-title/CorePageTitle';
import HelpMenu from './help-menu/HelpMenu';
import Core from './Core';

export default Core;
export { CorePageTitle, HelpMenu as CoreHelpMenu };
